import styled from "styled-components";

export const UploadButtonContainer = styled.div`
    position: absolute;
    top:3px;
    right:0;
`